export default __webpack_public_path__ + "static/ml-how-work3-96671c90a52ebcb58d321518d784ac42.png";